import React from "react";
import { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Box, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MsgObjetoCreado from "componentes/MsgObjetoCreado";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "helpers/API";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import { errorBackendMsg, getValorEditarODefault } from "helpers/helpers";

const useStyles = makeStyles((theme) => ({
    cardCrear: {
        height: 120,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
            cursor: "pointer",
        },
    },
    inputNuevaBanda: {
        width: "100%",
    },
}));

function ModuloForm({
    drawer,
    moduloEdit,
    keyLista,
    setKeyLista,
    setRecargarTabla,
}) {
    const classes = useStyles();
    const [creado, setCreado] = useState(null);

    // API Mensaje
    const [mensajeError, setMensajeError] = useState("");
    const [showError, setShowError] = useState(false);
    // API Mensaje Creado
    const [mensajeObjetoCreado, setMensajeObjetoCreado] = useState("");
    //CAMPOS
    const [feriadoInicial, setFeriadoInicial] = useState(null);
    ///////

    useEffect(() => {
        if (moduloEdit) {
            const dataEdit = {
                ...moduloEdit,
                fecha: parsearFechaParaFormik(moduloEdit.fecha),
                fechaEjecucion: parsearFechaParaFormik(
                    moduloEdit.fechaEjecucion
                ),
            };
            setFeriadoInicial(dataEdit);
        }
    }, []);

    const peticionBase = ({ url, dataRequest = {}, hook = false }) => {
        axios
            .post(url, dataRequest)
            .then(function (response) {
                if (response.data.error) {
                    setShowError(true);
                    setMensajeError(response.data.msg);
                } else {
                    if (Boolean(hook)) {
                        hook(response.data);
                    }
                }
            })
            .catch(function (error) {
                setShowError(true);
                setMensajeError(errorBackendMsg(error));
            });
    };

    const parsearFecha = (formikFecha) => {
        const date = new Date(formikFecha);
        const age = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${day}/${month}/${age}`;
    };

    const validationSchema = Yup.object({
        descripcion: Yup.string()
            .trim()
            .required("Campo requerido")
            .max(250, "Puede tener hasta ${max} caracteres"),
        fecha: Yup.date().required("Campo requerido"),
        fechaEjecucion: Yup.date().when("fecha", {
            is: (fecha) => fecha === "",
            then: Yup.date().required("Campo requerido"),
            otherwise: Yup.date()
                .required("Campo requerido")
                .min(
                    Yup.ref("fecha"),
                    ({ min }) =>
                        `La fecha debe ser posterior a ${parsearFecha(min)}`
                ),
        }),
    });

    const peticionABM = (data) => {
        const handleRespuesta = (data) => {
            setMensajeObjetoCreado(data.msg);
            setCreado(true);
            setKeyLista(keyLista + 1);
            setRecargarTabla(true);
        };

        if (moduloEdit) {
            let peticion = {
                url: "/generales/feriados/editar",
                hook: handleRespuesta,
                dataRequest: { ...data },
            };
            peticionBase(peticion);
        } else {
            let peticion = {
                url: "/generales/feriados/nuevo",
                hook: handleRespuesta,
                dataRequest: { ...data },
            };
            peticionBase(peticion);
        }
    };

    const parsearFechaParaBackend = (fecha) => {
        const partes = fecha.split("-");
        const age = partes[0];
        const month = partes[1];
        const day = partes[2];
        return `${day}-${month}-${age}`;
    };

    const parsearFechaParaFormik = (fecha) => {
        const partes = fecha.split("/");
        const day = partes[0];
        const month = partes[1];
        const age = partes[2];
        return `${age}-${month}-${day}`;
    };

    const formik = useFormik({
        initialValues: {
            id: getValorEditarODefault(feriadoInicial, "id", null),
            descripcion: getValorEditarODefault(
                feriadoInicial,
                "descripcion",
                ""
            ),
            fecha: getValorEditarODefault(feriadoInicial, "fecha", ""),
            fechaEjecucion: getValorEditarODefault(
                feriadoInicial,
                "fechaEjecucion",
                ""
            ),
        },
        enableReinitialize: Boolean(moduloEdit) ? true : false,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            const buildRequest = {
                ...values,
                fecha: parsearFechaParaBackend(values.fecha),
                fechaEjecucion: parsearFechaParaBackend(values.fechaEjecucion),
            };
            peticionABM(buildRequest);
            setSubmitting(false);
        },
    });

    return (
        <div
            style={{
                margin: "20px",
                maxWidth: "30vw",
                width: "30vw",
            }}
        >
            {creado && (
                <MsgObjetoCreado
                    msg={mensajeObjetoCreado}
                    setCreado={setCreado}
                    drawer={drawer}
                />
            )}
            <form onSubmit={formik.handleSubmit}>
                <Box>
                    <Typography variant="h5">
                        {moduloEdit ? "Actualizar " : "Nuevo "} Feriado
                    </Typography>
                </Box>
                <APIMensajeMUI
                    mt={10}
                    tipo="error"
                    showMensaje={showError}
                    msg={mensajeError}
                />
                <Box mt={1}>
                    <TextField
                        variant="outlined"
                        className={classes.inputNuevaBanda}
                        label="Descripción"
                        type="text"
                        id="descripcion"
                        name="descripcion"
                        value={formik.values.descripcion}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.descripcion &&
                            Boolean(formik.errors.descripcion)
                        }
                        helperText={
                            formik.touched.descripcion &&
                            formik.errors.descripcion
                        }
                    />
                </Box>
                <Box mt={2}>
                    <TextField
                        className={classes.inputNuevaBanda}
                        name="fecha"
                        label="Fecha Desde"
                        value={formik.values.fecha}
                        type="date"
                        onChange={(e) => {
                            formik.handleChange(e);
                            // Esto es un requerimiento para que automaticamente se setee el otro campo
                            formik.setFieldValue(
                                "fechaEjecucion",
                                e.target.value
                            );
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={
                            formik.touched.fecha && Boolean(formik.errors.fecha)
                        }
                        helperText={formik.touched.fecha && formik.errors.fecha}
                    />
                </Box>
                <Box mt={1}>
                    <TextField
                        className={classes.inputNuevaBanda}
                        name="fechaEjecucion"
                        label="Fecha Ejecución"
                        value={formik.values.fechaEjecucion}
                        type="date"
                        onChange={formik.handleChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={
                            formik.touched.fechaEjecucion &&
                            Boolean(formik.errors.fechaEjecucion)
                        }
                        helperText={
                            formik.touched.fechaEjecucion &&
                            formik.errors.fechaEjecucion
                        }
                    />
                </Box>
                <Box mt={3} style={{ float: "right" }}>
                    <Button type="submit" variant="contained" color="secondary">
                        Guardar
                    </Button>
                </Box>
            </form>
        </div>
    );
}
export default ModuloForm;
